/**
 * Export
 */

export const loadState = () => {
  return getStorage('state')
}
export const saveState = (state) => {
  return setStorage('state', state)
}

export const getStorage = (key) => {
  try {
    const serializedState = localStorage.getItem(key)
    if (serializedState === null) {
      return {}
    }
    return JSON.parse(serializedState)
  } catch (e) {
    return {}
  }
}
export const setStorage = (key, value) => {
  try {
    const serializedState = JSON.stringify(value)
    localStorage.setItem(key, serializedState)
  } catch (e) {
    console.error(e)
  }
}
window.getStorage = getStorage
window.setStorage = setStorage



// WEBPACK FOOTER //
// ./src/store/localStorage.js